/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  var down = document.querySelector("#scroll-down");
  var shopifySections = document.querySelectorAll(
    ".main-content .shopify-section"
  );
  var secondSec = shopifySections[1];

  if (down && shopifySections && secondSec) {
    down.href = "#" + secondSec.id;
  }

  var swatches = document.querySelectorAll(".swatch__label");
  var colorLabel = document.querySelector("#selectedVariant");

  if (swatches) {
    swatches.forEach(function (swatch) {
      swatch.addEventListener("click", function () {
        var swatch_data = swatch.getAttribute("data-swatch");
        colorLabel.textContent = swatch_data;
        const preOrder = swatch.getAttribute("data-preorder");
        const preShipping = swatch.getAttribute("data-shipping");
        $(".preorder-shippingtxt").text(preShipping);
        //alert("preOrder", preOrder);
        if(preOrder == "true"){
          $(".addtocart_btn").addClass("preorder");
          //$(".addtocart_btn span").text("Pre Order");
          $(".preorder-shippingtxtmain").show();
        }else{
          $(".addtocart_btn").removeClass("preorder");
          $(".preorder-shippingtxtmain").hide();
        }
      });
    });
  }

  var radioButtons = document.querySelectorAll(".radio__input");

  if (radioButtons) {
    radioButtons.forEach(function (radioBTN) {
      radioBTN.addEventListener("click", function () {
        var radio_data = radioBTN.value;
        colorLabel.textContent = radio_data;
      });
    });
  }

  // Mobile nav images

  document.querySelectorAll(".mobile-dropdown").forEach((container) => {
    const parentId = container.id;

    container.classList.add("temp-class");
    setTimeout(() => container.classList.remove("temp-class"), 0);

    if (parentId === "MobileNav--shop-0") {
      container.querySelector(".hero_1 a").innerHTML = "Personalise";

      container.querySelector(".hero_1 a").href = "/pages/personalize";

      container.querySelector(".hero_image_1").src =
        "https://cdn.shopify.com/s/files/1/0566/3902/9297/files/Tag_Arctic_dusk_3.jpg?v=1732199727";

      container.querySelector(".hero_2 a").innerHTML = "Lifetime Warranty";

      container.querySelector(".hero_2 a").href = "/pages/lifetime-warranty";

      container.querySelector(".hero_image_2").src =
        "https://cdn.shopify.com/s/files/1/0566/3902/9297/files/Medium_Arctic_Dusk_Czech1.jpg?v=1732029329";
    } else if (parentId === "MobileNav--why-wntr-is-better-1") {
      container.querySelector(".hero_1 a").innerHTML = "Shop Dawn Series";

      container.querySelector(".hero_1 a").href =
        "/collections/wntr-dawn-series";

      container.querySelector(".hero_image_1").src =
        "https://cdn.shopify.com/s/files/1/0566/3902/9297/files/shop_dawn_series.jpg?v=1731321060";

      container.querySelector(".hero_2 a").innerHTML = "Quality Testing";

      container.querySelector(".hero_2 a").href = "/pages/quality-testing";

      container.querySelector(".hero_image_2").src =
        "https://cdn.shopify.com/s/files/1/0566/3902/9297/files/quality_testing_cc943f59-cfde-4fb2-8c00-582dcb8e5073.jpg?v=1731321060";
    } else if (parentId === "MobileNav--concierge-3") {
      container.querySelector(".hero_1 a").innerHTML = "100 Days Return";

      container.querySelector(".hero_1 a").href = "/pages/return-policy";

      container.querySelector(".hero_image_1").src =
        "https://cdn.shopify.com/s/files/1/0566/3902/9297/files/100_days_return.jpg?v=1731146509";

      container.querySelector(".hero_2 a").innerHTML = "Gift Cards";

      container.querySelector(".hero_2 a").href = "/products/wntr-gift-cards";

      container.querySelector(".hero_image_2").src =
        "https://cdn.shopify.com/s/files/1/0566/3902/9297/files/WNTR_Gift_Card_Square_JPG.jpg?v=1732206239";
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    var productGrids = document.querySelectorAll(".product-grid-item");

    productGrids.forEach((productGrid) => {
      const swatchButtons = productGrid.querySelectorAll(".swatch__button");
      if (swatchButtons.length > 0) {
        swatchButtons[0].classList.add("selected");
      }
      swatchButtons.forEach((button) => {
        button.addEventListener("click", function () {
          swatchButtons.forEach((btn) => btn.classList.remove("selected"));
          button.classList.add("selected");
        });
      });
    });

    var pdVideos = document.querySelectorAll(".video-with-text__media video");
    pdVideos.forEach((pdVideo) => {
      pdVideo.setAttribute("loading", "lazy");
    });

    var pdImages = document.querySelectorAll(
      ".product-single__media .img-object-cover"
    );
    pdImages.forEach((pdImage) => {
      pdImage.setAttribute("loading", "eager");
    });
  });

  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


(function() {
  function enableVideoDrag() {
    var videoSlides = document.querySelectorAll('.product-single__media-slide[data-type="video"]');
    videoSlides.forEach(function(slide) {
      slide.dispatchEvent(new CustomEvent('theme:media:pause', {bubbles: true}));
    });
  }
  
  if (document.readyState === 'complete') {
    enableVideoDrag();
  }
  window.addEventListener('load', function() {
    enableVideoDrag();
    setTimeout(enableVideoDrag, 500);
    setTimeout(enableVideoDrag, 1000);
    setTimeout(enableVideoDrag, 2000);
    setTimeout(enableVideoDrag, 3000);
  });

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(enableVideoDrag, 500);
  });
 
  document.addEventListener('theme:media:play', function(e) {
    setTimeout(enableVideoDrag, 100);
    setTimeout(enableVideoDrag, 300);
  }, true);
  // Continuous check for first 5 seconds
  var checkCount = 0;
  var interval = setInterval(function() {
    enableVideoDrag();
    checkCount++;
    if (checkCount >= 10) {
      clearInterval(interval);
    }
  }, 500);
})(); 



 